import initCarouselSchoolLogos from './vendor/carouselSchoolLogos';

initCarouselSchoolLogos('.school-logo-carousel', 8, 3000);
